module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[112]111.6a650c7.woff2";